import { useDataAttributes } from '@data-attributes/use-data-attributes';
import { LinkButton } from '@eika/button';
import { IconTypes } from '@eika/icon';
import useTranslation from '@translation-utils/use-translation';
import { useState } from 'react';
import { AboutCalculationsModal } from '../about-calculations-modal/about-calculations-modal';

export const AboutCalculations = () => {
    const { totalsPanel } = useTranslation();
    const [open, setOpen] = useState<boolean>(false);
    const { aboutCalculationsInfoButtonDataAttrs } = useDataAttributes();

    const handleOnClick = () => {
        setOpen(true);
    };

    return (
        <div className="about-calculations-info-button">
            <LinkButton icon={IconTypes.INFO_24} onClick={handleOnClick} {...aboutCalculationsInfoButtonDataAttrs}>
                {totalsPanel.aboutCalculationsLinkText}
            </LinkButton>
            <AboutCalculationsModal open={open} setOpen={setOpen} shouldCloseOnOverlayClick />
        </div>
    );
};
